import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { ProductReviewsContainer } from '../../../../../containers/ProductReviewsContainer'
import { useProductReviewFilters } from '../../../../../lib/hooks/useProductReviewFilters'

import { Body, Button, MessageWrapper } from './styles'

export const ProductFilteredReviewsEmptyState = () => {
  const {
    magnolia: {
      reviewsPage: { filteredEmptyMessage, clearFilters },
    },
  } = useTranslation()

  const { results, status } = ProductReviewsContainer.useContainer()
  const { updateFilters } = useProductReviewFilters()

  if (status !== 'resolved') return null

  if (typeof results?.totalReviews === 'number') {
    // there are no reviews available regardless of filters
    if (results.totalReviews === 0 && results.reviews.length === 0) return null

    // there are reviews, and some are available after filters
    if (results.totalReviews > 0 && Number(results.totalFilteredReviews) > 0) return null
  } else {
    // if `results.totalReviews` isn't a number, we probably shouldn't be rendering
    return null
  }

  return (
    <Body>
      <MessageWrapper>{filteredEmptyMessage}</MessageWrapper>
      <Button variant='ghost' onClick={() => updateFilters({})}>
        {clearFilters}
      </Button>
    </Body>
  )
}
